import React, { FC } from "react";

import { SerializedStyles } from "@emotion/react";
import { Button, Text } from "@epignosis_llc/gnosis";
import { useResponsive } from "ahooks";

import { useApplyTranslations } from "@hooks";
import { useToggleSandboxModeURL } from "@hooks/api/user";

import NotificationBanner from "@components/ReusableComponents/NotificationBanner/NotificationBanner";

import { sandboxBannerContainer } from "./styles";

const SandboxBanner: FC = () => {
  const { t } = useApplyTranslations();
  const { lg } = useResponsive();
  const { mutate: switchBetweenSandboxAndMainDomain } = useToggleSandboxModeURL();

  return (
    <div css={(theme): SerializedStyles => sandboxBannerContainer(theme)}>
      <NotificationBanner
        variant="danger"
        title={t("sandbox.sandboxToggleItem")}
        description={lg ? t("sandbox.sandboxModeDescription") : ""}
        ariaLabel={t("sandbox.sandboxToggleItem")}
        actions={
          <Button
            className="exit-sandbox-btn"
            data-testid="exit-demo-mode-button"
            aria-label={t("sandbox.sandboxModeAction")}
            variant="link"
            size="sm"
            underlined={true}
            onClick={(): void => switchBetweenSandboxAndMainDomain()}
          >
            <Text fontSize="xs">{t("sandbox.sandboxModeAction")}</Text>
          </Button>
        }
      />
    </div>
  );
};

export default SandboxBanner;
